// extracted by mini-css-extract-plugin
export default {"Container":"Cards_Container__8aYFn","Cards-wrapper":"Cards_Cards-wrapper__K7hGb","card":"Cards_card__14c5v","icon-wrapper":"Cards_icon-wrapper__b5E7U"};